import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { CheckoutSummaryVM } from '../../../types/donation-flow.models';
import { CheckoutSummaryComponent } from '../checkout/summary.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'don-fee-review-modal',
    imports: [CommonModule, CheckoutSummaryComponent, TranslateModule],
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeeReviewModalComponent {
  /** Controla si el modal está visible (lo maneja el contenedor) */
  @Input() visible = false;

  /** ViewModel del summary (paso 3) */
  @Input() summaryVm: CheckoutSummaryVM | null = null;

  /** Propaga cambios del checkbox cover-fees al contenedor */
  @Output() summaryVmChange = new EventEmitter<CheckoutSummaryVM>();

  @Output() accept = new EventEmitter<void>();
  @Output() useAnotherCard = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  onAccept(): void { this.accept.emit(); }
  onUseAnotherCard(): void { this.useAnotherCard.emit(); }
  onCancel(): void { this.cancel.emit(); }
  onSummaryVmChange(vm: CheckoutSummaryVM): void { this.summaryVmChange.emit(vm); }
}
